import React, {useEffect} from 'react';
import AdminCompany from './Company'
import {observer} from 'mobx-react-lite'
import {useParams} from "react-router";
import adminStore from "../../storage/AdminStore";


const EditCompany = () => {
  const { id } = useParams();

  useEffect(() => {
    adminStore.getCompany(id)
  }, [id])

  return (
    <AdminCompany/>
  )
}

export default observer(EditCompany);